export const getTranslation = (key, fallback = '') =>
	window?.languageTranslations?.[key] ?? fallback;
